import React, {useRef, useState} from "react";
import {connect} from "dva";
import {reduxTemplateConfig, templateConfig} from "./config";
import handleFile from "@/utils/downloadExcelUtils";

import {framework_tool, utils_tool, component_tool} from '@/tool'
import {modelUtils} from "@/utils";

const {WizContainer, WizReduxTemplate} = framework_tool;

const Index = ({}) => {
  const [versionList, setVersionList] = useState([])
  const _wizTableList_searchRef = useRef()

  const _listHandler = (nextProps, nextState, key) => {
    const {success, msg} = nextProps?.[key] || {}
    if(!success) {
      wizNotice.error(msg)
    }
    return !!success;
  }
  const _cmdHandler = (nextProps, nextState, key) => {
    const {success, msg} = nextProps?.[key] || {}
    if(success) {
      wizNotice.success(msg)
    } else {
      wizNotice.error(msg)
    }
    return !!success;
  }

  const _templateConfig = templateConfig({
    versionList,
    _wizTableList_searchRef
  });
  const _reduxTemplateConfig = reduxTemplateConfig({
    templateConfig: _templateConfig,
    apiDataFormat: {
      list: _listHandler,
      export: handleFile.bind(this, _templateConfig?.content?.params?.columns, '能力积分-业务积分'),
      delete: _cmdHandler.bind(this),
    },
  })

  return (
    <WizReduxTemplate {..._reduxTemplateConfig}/>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(Index)
